import { heroLead, heroSide, heroHighlights } from '@/mocks/gossipData';

const HERO_IMG =
  'https://readdy.ai/api/search-image?query=Warm%20cinematic%20entertainment%20newsroom%20scene%20with%20television%20variety%20stage%20lights%20and%20popcorn%20and%20conversation%20bubbles%2C%20golden%20amber%20orange%20and%20cream%20sunset%20palette%2C%20magazine%20cover%20atmosphere%2C%20soft%20film%20grain%2C%20rich%20depth%20and%20premium%20editorial%20lighting&width=1600&height=900&seq=hero-today&orientation=landscape';

export default function Hero() {
  return (
    <section id="today" className="mx-auto max-w-7xl scroll-mt-20 px-4 pt-24 md:px-6">
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        {/* Lead story card */}
        <article className="relative lg:col-span-2">
          <div className="relative h-[380px] w-full overflow-hidden rounded-2xl md:h-[440px]">
            <img
              src={HERO_IMG}
              alt="昨日头条：一档新综艺首播即爆，话题两小时冲上热搜前排"
              title="昨日头条 - 新综艺首播即爆"
              className="h-full w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-foreground-950/10" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">{heroLead.tag}</span>
                <span className="text-xs text-background-200/90">{heroLead.time}</span>
              </div>
              <h2 className="mt-3 max-w-2xl font-heading text-2xl font-bold leading-snug text-background-50 md:text-[2.1rem]">
                {heroLead.title}
              </h2>
              <p className="mt-3 hidden max-w-2xl text-sm leading-6 text-background-200/95 sm:block">
                {heroLead.summary}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-3">
                <span className="inline-flex items-center gap-1.5 text-sm text-accent-200">
                  <i className="ri-fire-fill" /> {heroLead.heat}
                </span>
                <a
                  href="#essence"
                  className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/95 px-4 py-2 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-100"
                >
                  看这条怎么火的 <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>
          </div>
        </article>

        {/* Side list */}
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-1">
          {heroSide.map((s, i) => (
            <a
              key={i}
              href="#hot"
              className="group flex flex-col justify-between gap-2 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-secondary-50"
            >
              <div>
                <span className="inline-block rounded-md bg-primary-100 px-2 py-0.5 text-xs font-semibold text-primary-800">{s.tag}</span>
                <h3 className="mt-2 line-clamp-2 text-sm font-semibold leading-6 text-foreground-900 group-hover:text-foreground-950">
                  {s.title}
                </h3>
              </div>
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-fire-line text-accent-500" /> {s.heat}
              </span>
            </a>
          ))}
        </div>
      </div>

      {/* Highlights */}
      <div className="mt-5 grid grid-cols-3 gap-3 md:gap-4">
        {heroHighlights.map((h, i) => (
          <div
            key={i}
            className="flex flex-row items-center gap-3 rounded-2xl border border-background-200 bg-background-50 px-4 py-4 md:py-5"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-600">
              <i className={`${h.icon} text-lg`} />
            </span>
            <div className="min-w-0">
              <p className="truncate text-base font-bold text-foreground-950 md:text-lg">{h.value}</p>
              <p className="truncate text-xs text-foreground-500">{h.label}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}